import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { ApiConsumerSimple } from "../models/api-consumer-simple.model";
import { map, Observable } from 'rxjs';
import { ApiConsumer } from "../models/api-consumer.model";
import { ApiConsumerList } from "../models/ApiConsumerList.model";

export interface ApiConsumerRequest {
  name: string;
  webhookUrl: string;
  webhookVersion: string;
  enabled: boolean;
  webhooksEnabled: boolean;
  webhooksEnabledPatient: boolean;
  webhooksEnabledVisit: boolean;
  webhooksEnabledExpense: boolean;
  webhooksEnabledTrip: boolean;
  firstPartyConsumer?: boolean;
  oneTimePasswordEnabled?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ApiConsumerService {
  private _endpoint = '/apiconsumer';

  constructor(private readonly http: HttpClient) {
  }

  /**
   * Returns a list of all API consumers
   */
  getAllApiConsumers() {
    return this.http.get<ApiConsumerSimple>(environment.apiUrl + this._endpoint + '/all');
  }

  /**
   * Updates an existing API consumer
   */
  update(id: string, request: ApiConsumerRequest): Observable<any> {
    const body = {
      ...request,
      enabled: request.enabled ?? false,
      webhooksEnabled: request.webhooksEnabled ?? false,
      webhooksEnabledPatient: request.webhooksEnabledPatient ?? false,
      webhooksEnabledVisit: request.webhooksEnabledVisit ?? false,
      webhooksEnabledExpense: request.webhooksEnabledExpense ?? false,
      webhooksEnabledTrip: request.webhooksEnabledTrip ?? false,
      firstPartyConsumer: request.firstPartyConsumer ?? false,
      oneTimePasswordEnabled: request.oneTimePasswordEnabled ?? false,
    };

    return this.http.put(environment.apiUrl + this._endpoint + '/' + id, body);
  }

  /**
   * Creates a new API consumer
   */
  create(request: ApiConsumerRequest): Observable<any> {
    const body = {
      ...request,
      enabled: request.enabled ?? false,
      webhooksEnabled: request.webhooksEnabled ?? false,
      webhooksEnabledPatient: request.webhooksEnabledPatient ?? false,
      webhooksEnabledVisit: request.webhooksEnabledVisit ?? false,
      webhooksEnabledExpense: request.webhooksEnabledExpense ?? false,
      webhooksEnabledTrip: request.webhooksEnabledTrip ?? false,
      firstPartyConsumer: request.firstPartyConsumer ?? false,
      oneTimePasswordEnabled: request.oneTimePasswordEnabled ?? false,
    };

    return this.http.post(environment.apiUrl + this._endpoint, body);
  }

  /**
   * Rotates a consumers secondary API key
   */
  rotateSecondaryApiKey(id: string) {
    return this.http.put<ApiConsumer>(environment.apiUrl + this._endpoint + '/' + id + '/rotate-secondary-api-key', {});
  }

  /**
   * Rotates a consumers primary API key
   */
  rotatePrimaryApiKey(id: string) {
    return this.http.put<ApiConsumer>(environment.apiUrl + this._endpoint + '/' + id + '/rotate-primary-api-key', {});
  }

  /**
   * Retrieve a list of API consumers based on page number and optional keywords.
   */
  retrieveApiConsumers(page: number, keywords: string) {
    let params = new HttpParams().set('page', page.toString());

    if (keywords != null) {
      params = params.set('keywords', keywords);
    }

    return this.http.get<ApiConsumerList>(environment.apiUrl + this._endpoint, { params: params }).pipe(map(rsp => {
      rsp.results = rsp.results.map(r => new ApiConsumer(r));
      return rsp;
    }));
  }
}
